import React, { useState } from 'react'
import styled from 'styled-components'
import { TextInput } from 'grommet'
import { isEmailValid, isPasswordValid } from '@services/utils'
import { FormInputContainer, FormInputLabel } from '@appearance/styled'
import InputButton from '@components/Buttons/InputButton'
import i18n from '@localization/i18n'

export default ({
    text,
    comparisonText,
    label,
    placeholder,
    type = 'text',
    onChangeText,
    onDoneEdit,
    required,
    onError,
    width,
    disabled,
    autoFocus,
    buttonOnClick,
    buttonText = 'חפש',
    hideRequiredSign,
    buttonDisabled,
    min,
    max,
    isCreatePassword,
    onEnterPress,
}) => {
    const [isError, setIsError] = useState(false)
    const [innetErrorText, setInnerErrorText] = useState('')
    const isComparisonValid = (text) => {
        return !comparisonText || comparisonText === text
    }
    const verificationFunctions = {
        text: () => true,
        number: (value) => !isNaN(value),
        email: isEmailValid,
        password: (pass) => (isCreatePassword ? pass.length >= 8 : true),
    }
    const verificationFunction = verificationFunctions[type]

    const isValid = (text) => {
        return (
            (!required || (text && text.length > 0)) &&
            verificationFunction(text) &&
            isComparisonValid(text)
        )
    }

    const handleChangeText = (text) => {
        if (onChangeText) {
            onChangeText(text)
        }
        handleDone(text)
    }

    const handleDone = (text) => {
        const valid = isValid(text) ? true : false
        setInnerErrorText('')
        if (isCreatePassword && !verificationFunction(text)) {
            setInnerErrorText(i18n.t('general.invalid_password'))
        }
        if (type === 'password' && !isComparisonValid(text)) {
            setInnerErrorText(i18n.t('general.invalid_verify_password'))
        }

        if (onDoneEdit) {
            onDoneEdit(valid)
        }
        if (onError) {
            onError(!valid)
        }
        setIsError(!valid)
    }

    const keyPress = (event) => {
        if (event?.keyCode === 13) {
            onEnterPress && onEnterPress()
        }
    }
    return (
        <FormInputContainer lang={i18n.locale} width={width}>
            {label && (
                <FormInputLabel lang={i18n.locale}>
                    {label}
                    {required && !hideRequiredSign && (
                        <RequiredSign> * </RequiredSign>
                    )}
                </FormInputLabel>
            )}
            <Row>
                <StyledTextInput
                    autoFocus={autoFocus}
                    value={text}
                    type={type}
                    placeholder={placeholder}
                    onChange={(event) => handleChangeText(event.target.value)}
                    isError={isError}
                    disabled={disabled}
                    onBlur={() => handleDone(text)}
                    onFocus={() => setIsError(false)}
                    min={min}
                    max={max}
                    onKeyDown={keyPress}
                />
                {buttonOnClick && (
                    <InputButton
                        onClick={buttonOnClick}
                        text={buttonText}
                        disabled={buttonDisabled}
                    />
                )}
            </Row>
            {type === 'password' && (
                <InnerErrorMessage>{innetErrorText}</InnerErrorMessage>
            )}
        </FormInputContainer>
    )
}

const StyledTextInput = styled(TextInput)`
    padding: 8px;
    width: ${(p) => p.width || '100%'};
    background-color: #fff;
    border-color: ${(p) => (p.isError ? 'red' : '#ccc')};
    max-height: 40px;
`
const Row = styled.div`
    width: 100%;
    display: flex;
    & > div {
        position: initial;
    }
`
const RequiredSign = styled.span`
    color: red;
`
const InnerErrorMessage = styled.div`
    color: red;
    font-size: 13px;
    min-height: 22px;
`
